import { Injectable } from '@angular/core';

import { Observable, Subject, BehaviorSubject } from 'rxjs';

const MARKET_FEATURE = {
    name: 'market',
    version: 1,
    menuData: [{
        section: 0,
        after: 'World',
        item: {
            label: 'Market',
            routerLink: '/market',
            svg: 'market'
        }
    }]
};

const AUTH_FEATURE = {
    name: 'auth',
    version: 1
};

@Injectable()
export class VersionService {
    set data(value: IVersionData) {
        let versionData = value;
        if (!value) {
            versionData = {
                packageVersion: null,
                protocol: null,
                serverData: { features: null },
                useNativeAuth: null,
                users: null,
            }
        }

        // TODO: Fallback to support old server's versions
        if (!versionData.serverData.features) {
            versionData.serverData.features = [
                MARKET_FEATURE,
                AUTH_FEATURE
            ];
        };

        this._dataSbj.next(versionData);
    }

    get data(): IVersionData {
        return this._dataSbj.getValue();
    }

    _dataSbj: BehaviorSubject<IVersionData> = new BehaviorSubject(null);
    data$: Observable<IVersionData> = this._dataSbj.asObservable();

    _afterUpgradeSbj: Subject<void> = new Subject();
    afterUpgrade$: Observable<void> = this._afterUpgradeSbj.asObservable();

    constructor(
    ) {
    }

    getData(apiUrl: string): Promise<IVersionData> {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await fetch(`${ apiUrl }version`);
                const data = await res.json() as IVersionData;

                resolve(data);
            } catch (err) {
                reject(err);
            }
        });
    }

    afterUpgrade() {
        this._afterUpgradeSbj.next();
    }
}
